export default __webpack_public_path__ + "static/media/weight-loss_wegovy.eb841fcb.jpg";